module.exports = __webpack_public_path__ + "static/data/template.869b64b.json";